import React from "react";

const PermissionsTable = ({ permissions = [] }) => {
  return (
    <div 
      className="w-full bg-white rounded-3xl border border-[#5007C5] p-4 flex flex-col gap-3"
      style={{
        background: '#FCFCFC',
        border: '1px solid #5007C5',
        borderRadius: '24px',
        margin:'36px 24px',
        width: 'calc(100% - 48px)',
      }}
    >
      {permissions.map((permission, index) => (
        <div
          key={index}
          className="flex items-center justify-between px-4 py-3 border-b-[0.5px] border-[#5007C5] last:border-b-0"
          style={{
            borderBottom: index !== permissions.length - 1 ? '0.5px solid #5007C5' : 'none',
            padding: '10px 16px 12px',
          }}
        >
          <div className="flex-1 flex flex-col gap-2">
            <h3 
              className="text-black"
              style={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '19px',
                color: '#000000',
              }}
            >
              {permission.title}
            </h3>
            <p 
              className="text-black"
              style={{
                fontFamily: 'Inter',
                fontStyle: 'normal',
                fontWeight: 400,
                fontSize: '16px',
                lineHeight: '19px',
                color: '#000000',
              }}
            >
              {permission.description}
            </p>
          </div>

          <div className="ml-4 flex-shrink-0">
            {permission.isGranted ? (
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.0001 29.3333C8.63608 29.3333 2.66675 23.364 2.66675 16C2.66675 8.63596 8.63608 2.66663 16.0001 2.66663C23.3641 2.66663 29.3334 8.63596 29.3334 16C29.3334 23.364 23.3641 29.3333 16.0001 29.3333ZM14.4307 18.8533L10.7441 15.164L9.33342 16.5746L13.4921 20.736C13.7421 20.9859 14.0812 21.1263 14.4347 21.1263C14.7883 21.1263 15.1274 20.9859 15.3774 20.736L23.3134 12.8026L21.8974 11.3866L14.4307 18.8533Z"
                  fill="#32B765"
                />
              </svg>
            ) : (
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 2C8.2 2 2 8.2 2 16C2 23.8 8.2 30 16 30C23.8 30 30 23.8 30 16C30 8.2 23.8 2 16 2ZM21.4 23L16 17.6L10.6 23L9 21.4L14.4 16L9 10.6L10.6 9L16 14.4L21.4 9L23 10.6L17.6 16L23 21.4L21.4 23Z"
                  fill="#BD2626"
                />
              </svg>
            )}
          </div>
        </div>
      ))}

      {permissions.length === 0 && (
        <div className="px-4 py-8 text-center">
          <p 
            className="text-gray-500"
            style={{
              fontFamily: 'Inter',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '19px',
            }}
          >
            No permissions to display
          </p>
        </div>
      )}
    </div>
  );
};

export default PermissionsTable;
